<template>
  <div class="account-note">
    <div class="card-header bg-default">
      <span class="fa mr-1" :class="typeIcon"></span>
      {{ note.subject }}
      <span class="badge" :class="{
        'badge-success': note.resolved,
        'badge-danger': !note.resolved,
      }">
        {{ note.resolved ? 'Resolved' : 'Unresolved' }}
      </span>
    </div>
    <ul class="list-group list-group-flush">
      <li class="list-group-item" v-if="note.Account">
        <span class="fa fa-user mr-1"></span>
        <router-link :to="`/membership/members/${note.Account.uuid}`">
          {{ note.Account.dropdownLabel }}
        </router-link>
      </li>
      <li class="list-group-item" v-if="note.Car">
        <span class="fa fa-car mr-1"></span>
        <router-link :to="`/fleet/vehicles/${note.Car.uuid}`">
          {{ note.Car.dropdownLabel }}
        </router-link>
      </li>
      <li class="list-group-item" v-if="note.Reservation">
        <span class="fa fa-calendar-alt mr-1"></span>
        <router-link
        :to="`/fleet/reservations/${note.Reservation.uuid}`">
          {{ note.Reservation.dropdownLabel }}
        </router-link>
      </li>
      <li class="list-group-item" v-if="note.resolved">
        <template v-if="note.AdminResolved">
          <strong>Resolved by:</strong>
          <router-link :to="`/membership/members/${note.AdminResolved.uuid}`">
            {{ note.AdminResolved.dropdownLabel }}
          </router-link>
        </template>
      </li>
    </ul>
    <div class="card-body">
      <h6 class="card-subtitle mb-2 text-muted">
        <span class="fa fa-clock mr-1"></span> {{ note.dateLogged | date_format('Australia/Melbourne') }}
      </h6>
      <div class="card-text" v-html="nl2br(note.description)"></div>
      <p v-if="note.AmazonImages.length > 0"><span class="fa fa-paperclip mr-1"></span> Attachments</p>
      <template v-for="(image, index) in note.AmazonImages">
        <a v-if="image.objectKey.includes('pdf')" target="_blank" :key="index"
        :href="`https://techcar-dev.s3.amazonaws.com/${image.objectKey}`">
          PDF {{ index + 1 }}
        </a>
        <a v-else target="_blank" :key="index"
        :href="`https://techcar-dev.s3.amazonaws.com/${image.objectKey}`">
          <img :src="`https://techcar-dev.s3.amazonaws.com/${image.objectKey}`" class="img-fluid img-thumbnail mb-2" />
        </a>
      </template>
    </div>
    <div class="card-footer clearfix">
      <em class="align-middle" v-if="note.AdminResponsible">
        <strong>Admin Responsible: </strong>
        <router-link
        :to="`/membership/members/${note.AdminResponsible.uuid}`">
          {{ note.AdminResponsible.dropdownLabel }}
        </router-link>
      </em>
      <em class="align-middle" v-else>System Generated</em>
      <button class="btn btn-sm btn-success float-right" type="button"
      @click="resolveNote()" v-if="!note.resolved">
        <span class="fa fa-check"></span> Mark As Resolved
      </button>
    </div>
  </div>
</template>

<script>
  import { RESOLVE_NOTE } from '@/vuex/types'
  import { iconMap } from '@/util/helpers'
  export default {
    name: 'AccountNoteCard',
    props: {
      object: {
        type: Object
      }
    },
    data () {
      return {
        updatedNote: {}
      }
    },
    computed: {
      note () {
        return {
          Account: {},
          AdminResolved: {},
          AdminResponsible: {},
          AmazonImages: [],
          Car: {},
          Reservation: {},
          ...this.object,
          ...this.updatedNote
        }
      },
      typeIcon () {
        for (let key in iconMap.AccountNote) {
          if (this.note.subject.includes(key)) {
            return iconMap.AccountNote[key]
          }
        }
      }
    },
    methods: {
      nl2br (message) {
        return this.$root.$options.filters['nl2br'](message)
      },
      async resolveNote () {
        let result = await this.$store.dispatch(RESOLVE_NOTE, this.note.uuid)
        this.updatedNote = result
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/AccountNote.vue